import React, { memo } from "react";

import { FileSpreadsheetIcon, LoaderIcon, TableIcon } from "lucide-react";

const FileUploadStep = ({
  isDragActive,
  isProcessing,
  getRootProps,
  getInputProps,
  onContinueWithEmptyTable,
  templateUrl,
}) => {
  const handleDownload = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!templateUrl) return;

    try {
      const response = await fetch(templateUrl);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "template.csv";
      link.click();

      URL.revokeObjectURL(url);
    } catch {
      window.open(templateUrl, "_blank");
    }
  };

  return (
    <div className="space-y-4">
      {templateUrl && (
        <div className="flex justify-center">
          <button
            onClick={handleDownload}
            className="inline-flex items-center rounded-md bg-blue-50 px-4 py-2 text-sm font-medium text-blue-600 hover:bg-blue-100 hover:text-blue-700"
            type="button"
          >
            <FileSpreadsheetIcon className="mr-2 h-4 w-4" />
            CSV Şablonu İndir
          </button>
        </div>
      )}

      <div className="flex flex-row gap-4">
        <div
          {...getRootProps()}
          className={`flex flex-1 cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed p-10 text-center transition-colors ${
            isDragActive
              ? "border-blue-500 bg-blue-50"
              : "border-gray-300 hover:border-blue-400 hover:bg-blue-50/50"
          }`}
        >
          <input {...getInputProps()} />
          {isProcessing ? (
            <LoaderIcon className="mx-auto h-16 w-16 animate-spin text-blue-600" />
          ) : (
            <FileSpreadsheetIcon className="mx-auto h-16 w-16 text-blue-600" />
          )}
          <p className="mt-4 text-base font-medium text-gray-700">
            {isDragActive ? "Dosyayı buraya bırakın" : "CSV dosyasını yükleyin"}
          </p>
          <p className="mt-2 text-sm text-gray-500">
            Dosyayı sürükleyip bırakın veya{" "}
            <span className="font-medium text-blue-600">
              gözatmak için tıklayın
            </span>
          </p>
          <p className="mt-2 text-xs text-gray-400">Desteklenen format: .csv</p>
        </div>

        <button
          onClick={onContinueWithEmptyTable}
          type="button"
          className="flex flex-1 cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 p-10 text-center transition-colors hover:border-green-400 hover:bg-green-50/50"
        >
          <TableIcon className="mx-auto h-16 w-16 text-green-600" />
          <p className="mt-4 text-base font-medium text-gray-700">
            Boş tablo ile devam et
          </p>
          <p className="mt-2 text-sm text-gray-500">
            Boş bir tablo ile başlayıp verileri manuel olarak girin
          </p>
        </button>
      </div>
    </div>
  );
};

export default memo(FileUploadStep);
